import { s, h } from '../lib/sx'
import { A } from '../lib/router'

export function NotFound() {
  return (
    <section style={s('background:#1B2430;color:#F2F4F6;')}>
      <div style={s('max-width:1320px;margin:0 auto;padding:clamp(48px,7vw,88px) clamp(18px,4vw,32px) clamp(48px,7vw,110px);')}>
        <div style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.24em;text-transform:uppercase;color:#E06A20;")}>Error 404</div>
        <h1 style={s('font-family:Archivo,sans-serif;font-weight:800;font-size:clamp(42px,5.8vw,80px);line-height:0.94;letter-spacing:-0.04em;margin:22px 0 22px;max-width:900px;')}>That page is not on the drawing.</h1>
        <p style={s('font-size:18px;line-height:1.6;color:#B8C0CA;max-width:640px;margin:0 0 34px;')}>The address you followed does not match anything on this site. It may have moved, or the link may be wrong.</p>
        <A href="/" style={s('background:#1F5C99;color:#FFFFFF;padding:17px 30px;font-size:14px;font-weight:600;display:inline-block;')} className={h('background:#17497A;color:#FFFFFF;')}>
          Back to the home page
        </A>
      </div>
    </section>
  )
}
